import type { SignUpConfig } from '#types/config/components/form/signUp'

export default {
  fieldsOrder: [
    'firstName',
    'lastName',
    'birthDate',
    'phone',
    'gender',
    'email',
    'password'
  ],
  showSignIn: true
} satisfies Partial<SignUpConfig>
